import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

import { get } from './get';

type TableFriendly = 'activities' | 'lists' | 'reviews' | 'trails' | 'waypoints';
type TableName = 'at_map_markers' | 'at_maps' | 'lists' | 'trail_reviews' | 'trails' | 'trail_details';

export type LocalizedData = {
  id: number;
  content: string;
  column_name: string;
  is_source: boolean;
  language: LanguageRegionCode;
  row_id: number;
  table: TableName;
  translated_by: string;
};

const tableMap: Record<TableFriendly, TableName> = {
  activities: 'at_maps',
  lists: 'lists',
  reviews: 'trail_reviews',
  trails: 'trails',
  waypoints: 'at_map_markers'
};

export type DatabaseInfo = {
  table: TableFriendly;
  row: string | number;
  column: string;
};

export { type TableFriendly, type TableName, tableMap };

export const localizeContent = (table: TableName, columnName: string, rowId: string | number) =>
  get<LocalizedData[]>(`/api/alltrails/localizations?table=${table}&columnName=${columnName}&rowId=${rowId}`);
